module.exports = __webpack_public_path__ + "static/3bb8861b05559685d3cc23f90792840d9542eb4d0d41efa10830901e15af56f5-cd9bbd17fbc30708f873ccc6f2890e8f.jpeg";